import { MnemoLoading, ModalHandler } from "components/misc";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  Row,
  Col,
  Button,
} from "design-react-kit";
import React, { Component } from "react";
import { AdminSurveyQuestion } from "./AdminSurveyQuestion";
import { AdminSurveyFormListAnswer } from "./AdminSurveyFormListAnswer";
import { adminService } from "libs";

export class AdminSurveyForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      idSurvey: parseInt(this.props.idSurvey) || 0,
      surveyQuestions: null,
      defaultAccordionState: {},
      idQuestion: null,
      addNewQuestion: false,
      rndKey: 0,
      loading: true,
    };
  }

  componentDidMount() {
    if (this.state.idSurvey > 0) {
      this.loadQuestions(this.state.idSurvey);
    }
  }

  loadQuestions = (idSurvey) => {
    adminService
      .loadSurveyQuestions(idSurvey)
      .then(({ data }) => {
        this.setState({
          surveyQuestions: data.payload.surveyQuestions,
          loading: false,
        });
      })
      .catch(() => this.setState({ loading: false }));
  };

  accordionToggle = (idQuestion) => {
    this.setState((prevState) => {
      const defaultAccordionState = { ...prevState.defaultAccordionState };
      defaultAccordionState[`collapse${idQuestion}`] =
        !prevState.defaultAccordionState[`collapse${idQuestion}`];
      return { defaultAccordionState, idQuestion, rndKey: Math.random() };
    });
  };

  deleteRecord = (e, idQuestion) => {
    e.stopPropagation();
    ModalHandler.show(
      idQuestion,
      "Eliminazione domanda",
      "Vuoi davvero eliminare questa domanda?",
      null,
      this.deleteConfirmed
    );
  };

  deleteConfirmed = (idQuestion) => {
    adminService
      .deleteSurveyQuestion(idQuestion)
      .then(() => {
        this.setState({ loading: true });
        this.loadQuestions(this.state.idSurvey);
      })
      .catch(console.error);
  };

  renderQuestions = () => {
    const { loading, surveyQuestions, defaultAccordionState, addNewQuestion } =
      this.state;

    if (loading) return <MnemoLoading />;

    return (
      <>
        {!addNewQuestion && (
          <Button
            color="primary bg-dark my-3"
            onClick={() => this.setState({ addNewQuestion: true })}
          >
            Aggiungi domanda
          </Button>
        )}

        {addNewQuestion && (
          <AdminSurveyQuestion
            idSurvey={this.state.idSurvey}
            loadQuestions={this.loadQuestions}
            onCancel={() => this.setState({ addNewQuestion: false })}
            formActive={true}
          />
        )}

        <Accordion className="mt-4">
          {surveyQuestions.map((item, i) => (
            <div key={`survey-${i}`}>
              <AccordionHeader
                active={defaultAccordionState[`collapse${item.id}`]}
                onToggle={() => this.accordionToggle(item.id)}
              >
                Domanda {item.order}. <b>{item.label}</b>
              </AccordionHeader>
              <AccordionBody
                active={defaultAccordionState[`collapse${item.id}`]}
              >
                <Row>
                  <Col sm={12}>
                    <AdminSurveyQuestion
                      key={`survey-q-${item.id}`}
                      idQuestion={item.id}
                      questionValue={item}
                      loadQuestions={this.loadQuestions}
                      deleteRecord={(e) => this.deleteRecord(e, item.id)}
                    />
                  </Col>

                  <Col sm={12} className="header-answer-card-wrapper">
                    <h4>Opzioni di risposta</h4>
                    <AdminSurveyFormListAnswer idQuestion={item.id} />
                  </Col>
                </Row>
              </AccordionBody>
            </div>
          ))}
        </Accordion>
      </>
    );
  };

  render() {
    if (!this.state.surveyQuestions) return null;
    return this.renderQuestions();
  }
}
